//react
import React, { Component } from 'react';

//components
import Cta from '../../../components/cta/cta';
import Translation from '../../../components/translation/translation';
import VideoPlayer from '../../../components/videoPlayer/videoPlayer';

//data
import dataTranslations from './translations.json';

class PublicUsingNyxoidVideo extends Component {
	render() {
		const culture = this.props.culture;

		return (
			<div className="content-page__content">
				<h1><Translation culture={culture} data={dataTranslations} name="title" /></h1>
				<p><Translation culture={culture} data={dataTranslations} name="body" /></p>
				<ul>
					<li><Translation culture={culture} data={dataTranslations} name="listItem1" /></li>
					<li><Translation culture={culture} data={dataTranslations} name="listItem2" /></li>
					<li><Translation culture={culture} data={dataTranslations} name="listItem3" /></li>
					<li><Translation culture={culture} data={dataTranslations} name="listItem4" /></li>
				</ul>
				<p><b><Translation culture={culture} data={dataTranslations} name="reminder" /></b></p>

				<VideoPlayer culture={culture} />

				<small><b><Translation culture={culture} data={dataTranslations} name="referencesTitle" /></b> <Translation culture={culture} data={dataTranslations} name="referencesBody" /></small>

				<Cta culture={culture} data={dataTranslations} />

				<div className="content-page__footer">
					<p><Translation culture={culture} data={dataTranslations} name="footer" /></p>
				</div>
			</div>
		);
	}
}

export default PublicUsingNyxoidVideo;



// WEBPACK FOOTER //
// ./src/content/public/usingNyxoidVideo/usingNyxoidVideo.js